import React, {useState, useContext} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Text, View, Pressable } from 'react-native';
import { EXPENSES_WITH_COUNT, HIDE_EXPENSE } from './queries';
import { useMutation } from '@apollo/client';
// import SubNav from './SubNav';
import { Link } from 'app/src/utils/routing';
import { useParams } from 'react-router-dom';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   SubNavContainer,
   TableNavbarContainer
} from '../../elements';
import Modal from '../../elements/Modal';
import NewExpense from './new';
import EditExpense from './edit';
import currencyFormatter from '../../utils/currencyFormatter';
import SubNav from '../../elements/SubNav';
import moment from 'moment';
import AuthContext from '../../contexts/AuthContext';

const inputStyle = {
  marginBottom: '10px'
}

const Expenses = (props) => {
  const { user } = useContext(AuthContext);
  const { assetId } = useParams();
  const { asset, nestedSubNav } = props;
  const [refetch, setRefetch] = useState();
  const [clickedExpense, setClickedExpense] = useState();
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [showEditExpenseModal, setShowEditExpenseModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    // filterColumns: [],
    // filterNames: [],
    scopes: ['accounts_payable'],
  };
  const [hideExpense] = useMutation(
    HIDE_EXPENSE, { onCompleted: refetch }
  )

  const onHide = (expenseId) => {
    hideExpense({ variables: { id: expenseId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'status',
      label: 'Status',
      content: (entry) => {
        return entry.entry.status
      }
    },
    {
      key: 'vendorId',
      label: 'Vendor',
      content: (entry) => {
        return entry.entry.vendor?.name
      }
    },
    {
      key: 'total',
      label: 'Amount',
      content: (entry) => {
        return currencyFormatter(entry.entry.total)
      }
    },
    {
      key: 'invoiceNumber',
      label: 'Invoice Number',
      content: (entry) => {
        return entry.entry.invoiceNumber
      }
    },
    {
      key: 'paymentMethod',
      label: 'Payment Method',
      content: (entry) => {
        return entry.entry.paymentMethod
      }
    },
    {
      key: 'paymentReference',
      label: 'Payment Reference',
      content: (entry) => {
        return entry.entry.paymentReference
      }
    },
    {
      key: 'clearedOn',
      label: 'Cleared Date',
      content: (entry) => {
        return entry.entry.clearedOn ?
          moment(entry.entry.clearedOn).format('M-DD-YY') :
          '';
      }
    },
    {
      key: 'description',
      label: 'description',
      content: (entry) => {
        return entry.entry.description
      }
    },
    {
      key: 'requestedById',
      label: 'Requested By',
      content: (entry) => {
        return entry.entry.requestedBy ?
          `${entry.entry.requestedBy?.firstName} ${entry.entry.requestedBy?.lastName}` :
          ''
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        if (user?.accounting) {
          return (
            <LinkContainer>
              <Pressable
                onPress={() => {
                  setClickedExpense(entry.entry);
                  setShowEditExpenseModal(true)
                }}
                style={{marginLeft: '10px'}}
                key={`sale-expense-link-${entry.entry.id}`}
                name={`sale-expense-link-${entry.entry.id}`}
              >
                <Text>
                  {entry.entry.status === 'Purchase Order' ?
                    'Edit Purchase Order' : 'Edit'
                  }
                </Text>
              </Pressable>
            </LinkContainer>
          )
        }
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        {/* <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Sale Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.name || ''}
            style={inputStyle}
          />
          <Text>Start:</Text>
          <input
            type={'text'}
            name="startAt"
            onChange={e => setFilter('startAt', e.target.value)}
            value={filters.startAt || ''}
            style={inputStyle}
          />
          <Text>End:</Text>
          <input
            type={'text'}
            name="endAt"
            onChange={e => setFilter('endAt', e.target.value)}
            value={filters.endAt || ''}
            style={inputStyle}
          />
          <Text>Pre Bid Open At:</Text>
          <input
            type={'text'}
            name="preBidOpenAt"
            onChange={e => setFilter('preBidOpenAt', e.target.value)}
            value={filters.preBidOpenAt || ''}
            style={inputStyle}
          />
          <Text>Status:</Text>
          <select
            type={'select'}
            name="status"
            onChange={e => setFilter('status', e.target.value)}
            value={filters.status || ''}
          >
            <option key={`status-all`}>
              {'All'}
            </option>
            {STATUSES.map(status =>
              <option key={`status-${status}`}>
                {status}
              </option>
            )}
          </select>
        </View> */}
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      {!nestedSubNav &&
        <SubNavContainer>
          <SubNav>
            {getSubNavContents()}
          </SubNav>
        </SubNavContainer>
      }
      <ContentContainer>
        <PageTitle>Expenses</PageTitle>
        <br /><br />
        <TableContainer>
          {nestedSubNav &&
            <TableNavbarContainer>
              <SubNav>
                {getSubNavContents()}
              </SubNav>
            </TableNavbarContainer>
          }
          <DataTable.Gql
            setRefetch={setRefetch}
            query={EXPENSES_WITH_COUNT}
            queryName='expensesWithCount'
            columns={columns}
            // buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            // setSettings={setSettings}
            // dataUpdated={data => setFilterOptions(data?.expensesWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {showEditExpenseModal &&
        <Modal
          refetch={refetch}
          showModal={showEditExpenseModal}
          setShowModal={setShowEditExpenseModal}
          modalType={'Edit Expense'}
          objectName={clickedExpense.name}
        >
          <EditExpense
            setShowModal={setShowEditExpenseModal}
            refetch={refetch}
            expense={clickedExpense}
            asset={asset}
            markAsPaid={clickedExpense.status === 'Purchase Order' ?
              true : false
            }
          />
        </Modal>
      }
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <View>
        {getLinks()}
      </View>
    )
    function getLinks() {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddExpenseModal(true)}
          >
            <Text>+ Add Expense</Text>
          </Pressable>
          {showAddExpenseModal &&
            <Modal
              showModal={showAddExpenseModal}
              setShowModal={setShowAddExpenseModal}
              modalType={asset ? `Add Expense - ${asset.name}` : 'Add Expense'}
            >
              <NewExpense
                setShowModal={setShowAddExpenseModal}
                refetch={refetch}
                knownAssetId={assetId}
                expense={clickedExpense}
                setClickedExpense={setClickedExpense}
                setShowAddExpenseModal={setShowAddExpenseModal}
                setShowEditExpenseModal={setShowEditExpenseModal}
              />
            </Modal>
          }
        </View>
      )
    }
  }
}

export default Expenses;
